export const LOCALSTORAGES = {
  ACCESS_PLATFORM_ON: 'access-plataform-on',
  DATE_INIT_QUIZZ: 'date-init-quizz',
};
